import { useMemo } from "react";
import { Object3D } from "three";

export const useCloneGLTFMaterials = (object: Object3D): Object3D => {
    return useMemo(() => {
        object.traverse((node: any) => {
            if (node?.isMesh || node?.isSkinnedMesh) {
              const materialArray = Array.isArray(node.material)
                ? node.material
                : [node.material];
              for (let i = 0; i < materialArray.length; i++) {
                const material = materialArray[i].clone();
                node.material = material;
                node.frustumCulled = false;
              }
            }
        });
        return object;
    }, [object])
}
